import { ChangeEvent } from "react";

import Select from "components/botanic/Select";
import Option from "components/Option";

const DaySelect = ({
  daysInSelectedMonth,
  defaultValue,
  id,
  onChange,
}: {
  daysInSelectedMonth: number;
  defaultValue: number;
  id: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}) => {
  const days: number[] = [];
  for (let i = 1; i <= daysInSelectedMonth; i++) {
    days.push(i);
  }

  return (
    <Select
      id={`${id}-day-select`}
      label="Day"
      defaultValue={defaultValue}
      onChange={onChange}
    >
      <Option value=""></Option>
      {days.map((day) => (
        <Option value={day} key={day}>
          {day}
        </Option>
      ))}
    </Select>
  );
};

export default DaySelect;
